import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { truncate } from 'fs/promises';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import {ArtistPortfolioProductsService,PortfolioProductViewModel, ShareableProductLink,} from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { ArtistProductsService, ArtistProductSummary,} from 'src/app/Services/artistproducts.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
@Component({
    selector: 'app-shared-list-products',
    templateUrl: './shared-list-products.component.html',
    styleUrls: ['./shared-list-products.component.css'],
    standalone: false
})
export class SharedListProductsComponent implements OnInit {
  public linkid!: string;
  public sharedProducts!: PortfolioProductViewModel[];
  public numberOfColumnToShow: number | null = null;
  public IsShowProfile!: boolean;
  public SharedByUserId!: string;
  public CreatedBy!: string;
  public currencyCode!: string;
  public SharedDate?: Date;
  public SharedBy!: string;
  public SharedById!: string;
  public Profile!: string;
  public AboutMe!: string;
  public Description: string | undefined;
  public Title: string | undefined;
  public IsSharedByArtist!: boolean;
  public ProfilePicture!: string;
  public BusinessName!: string;
  public authConfig!: AuthConfig;
  public showProductDialog: boolean = false;
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public isPortfolioActive: boolean = false;
  public selectedProduct!: ArtistProductSummary;
  public selectedGalleryProduct!: ArtistProduct 
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private artistProductsService: ArtistProductsService,
    private ngxSpinnerService: NgxSpinnerService,
    private artistPortfolioProductsService: ArtistPortfolioProductsService
  ) {}
  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    this.route.params.subscribe((params) => {
      this.linkid = params['linkid'];
      if (this.linkid) {
        this.getShareableProducts();
        this.currencyCode = this.authService.getCurrencyCode() || 'USD';
      }
    });   
  }

  private getShareableProducts(): void {
    this.ngxSpinnerService.show();
    this.artistPortfolioProductsService
      .getArtistProtfolioProduct(this.linkid)
      .subscribe(
        (response: ShareableProductLink) => {
          console.log(response);
          if(response){
            this.isPortfolioActive = false
            this.IsSharedByArtist = response.IsSharedByArtist
            if(this.IsSharedByArtist){
              this.isArtist = true
              this.isGallery = false
            }else{
              this.isArtist = false
              this.isGallery = true
            }
            this.sharedProducts = response.PortfolioProductsViewModel;
            if (response.PortfolioProductsViewModel) {
              console.log(
                'response.ShareableLinkProducts ',
                response.PortfolioProductsViewModel
              );
            }
            this.SharedDate = response.CreatedDate;
            this.SharedBy = response.CreatedBy;
            this.SharedById = response.ShareById;
            this.AboutMe = response.AboutMe;
            this.IsSharedByArtist = response.IsSharedByArtist;
            this.BusinessName = response.BusinessName;
            this.ProfilePicture = response.ProfilePicture;
            this.numberOfColumnToShow = response.NumberOfColumnToShow;
            this.Title = response.Title
            this.Description = response.Description
            if (this.numberOfColumnToShow == 0) {
              response.NumberOfColumnToShow === 2;
            }
            this.IsShowProfile = response.IsShowProfile;
            console.log('Fetched shareable products:', this.sharedProducts);
            this.ngxSpinnerService.hide();
          }else{
            this.isPortfolioActive = true
            this.ngxSpinnerService.hide();
          }
        },
        (error) => {
          console.error('Error fetching shareable products:', error);
          this.ngxSpinnerService.hide();
        }
      );
  }

  public showProductDetail(event: ArtistProductSummary, inventoryType: 'artist' | 'gallery') {
    // inventoryType === 'artist' ? this.selectedProduct = event as ArtistProductSummary : this.selectedGalleryProduct = event as ArtistProduct;
    if(inventoryType === 'artist'){
      this.selectedProduct = event
    }else{
      const mappedGalleryProduct = this.mapGalleryProduct(event);  // Map the gallery product
      this.selectedGalleryProduct = mappedGalleryProduct // Add the mapped product to the array
    }
    this.showProductDialog = true
    // this.router.navigate([
    //   event.ArtistId,
    //   'artworks',
    //   event.Id,
    // ]);
  }

  private mapGalleryProduct(event: ArtistProductSummary) {
    const artistProductSummary = event;  // event is already the individual product
    
    return {
        Id: artistProductSummary.Id,
        ArtistProductId: artistProductSummary.Id,
        SerialNumber: artistProductSummary.SerialNumber || '',
        ArtistId: artistProductSummary.ArtistId,
        Name: artistProductSummary.Name,
        ArtistRevenue: artistProductSummary.ArtistRevenue,
        ArtistShortDescription: artistProductSummary.ArtistShortDescription || '',
        ArtistLongDescription: artistProductSummary.ArtistLongDescription || '',
        ArtistSocialMediaDescription: artistProductSummary.ArtistSocialMediaDescription || '',
        ProductImgUrl: artistProductSummary.ProductImgUrl,
        Length: artistProductSummary.Length,
        Width: artistProductSummary.Width,
        Height: artistProductSummary.Height,
        Weight: artistProductSummary.Weight,
        Category: artistProductSummary.Category,
        SeriesId: artistProductSummary.SeriesId || null,
        ClayId: artistProductSummary.ClayId || null,
        CreatedDate: artistProductSummary.CreatedDate,
        IsActive: artistProductSummary.IsActive,
        ArtTypeId: artistProductSummary.ArtTypeId,
        Comment: '',
        ArtTypeName: artistProductSummary.ArtTypeName,
        IsAccepted: false, 
        SelectedGlazes: artistProductSummary.SelectedGlazes,
        ArtistProductLog: [], 
        IsSyncToSquarePos: false, 
        IsSyncToShopify: false, 
        IsSyncToWooCommerce: false, 
        IsSyncToWix: false, 
        ArtistProductLogs: [], 
        ArtistProductImages: []
    };
  }

  // public navigateToViewProfile() {
  //   if (this.SharedById && this.IsSharedByArtist) {
  //     this.router.navigate(['/view-artist-profile', this.SharedById]);
  //   } else if (this.SharedById && !this.IsSharedByArtist) {
  //     this.router.navigate(['/view-gallery-profile', this.SharedById]);
  //   }
  // }

  public closeArtistSelectedProductDialog(): void {
    this.showProductDialog = false;
  }
}
